import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "o-nav" }
const _hoisted_2 = { class: "o-nav__logo" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "c-logo__img",
  src: _imports_0,
  alt: "Enrian Partners a.s. logo"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "c-logo__name" }, [
  /*#__PURE__*/_createTextVNode("Design System "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Tutorial")
], -1)
const _hoisted_5 = { class: "o-nav__list" }
const _hoisted_6 = {
  class: "c-nav",
  role: "navigation",
  "aria-label": "Main Navigation"
}
const _hoisted_7 = { class: "c-nav__list" }
const _hoisted_8 = { class: "c-nav__item" }
const _hoisted_9 = { class: "c-nav__icon" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "c-nav__name" }, "How to use", -1)
const _hoisted_11 = { class: "c-nav__item" }
const _hoisted_12 = { class: "c-nav__icon" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "c-nav__name" }, "Design", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_16 = { class: "c-subnav__item" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Colors ")
const _hoisted_18 = { class: "c-subnav__item" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Typography ")
const _hoisted_20 = { class: "c-nav__item" }
const _hoisted_21 = { class: "c-nav__icon" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "c-nav__name" }, "Layouts", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_25 = { class: "c-subnav__item" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Responsive Breakpoints ")
const _hoisted_27 = { class: "c-subnav__item" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Application Layouts ")
const _hoisted_29 = { class: "c-subnav__item" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Layout Objects ")
const _hoisted_31 = { class: "c-subnav__item" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Grid System ")
const _hoisted_33 = { class: "c-subnav__item" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Layout Helpers ")
const _hoisted_35 = { class: "c-nav__item" }
const _hoisted_36 = { class: "c-nav__icon" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "c-nav__name" }, "Forms", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1)
const _hoisted_39 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_40 = { class: "c-subnav__item" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Form Group Object ")
const _hoisted_42 = { class: "c-subnav__item" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Basic Input & Form Messages ")
const _hoisted_44 = { class: "c-subnav__item" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Checkbox, Radio & Switch ")
const _hoisted_46 = { class: "c-subnav__item" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Select & Option ")
const _hoisted_48 = { class: "c-subnav__item" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Input with Icon & File upload ")
const _hoisted_50 = { class: "c-nav__item" }
const _hoisted_51 = { class: "c-nav__icon" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "c-nav__name" }, "Components", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1)
const _hoisted_54 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_55 = { class: "c-subnav__item" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Button ")
const _hoisted_57 = { class: "c-subnav__item" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Box ")
const _hoisted_59 = { class: "c-subnav__item" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Hint ")
const _hoisted_61 = { class: "c-subnav__item" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Pill ")
const _hoisted_63 = { class: "c-subnav__item" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Table ")
const _hoisted_65 = { class: "c-subnav__item" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Tabs ")
const _hoisted_67 = { class: "c-nav__item" }
const _hoisted_68 = { class: "c-nav__icon" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "c-nav__name" }, "Utility Classes", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1)
const _hoisted_71 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_72 = { class: "c-subnav__item" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" How to use Utility classes ")
const _hoisted_74 = { class: "c-subnav__item" }
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" Colors ")
const _hoisted_76 = { class: "c-subnav__item" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" Typography ")
const _hoisted_78 = { class: "c-subnav__item" }
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" Spacings ")
const _hoisted_80 = { class: "c-subnav__item" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" Layout Helpers ")
const _hoisted_82 = { class: "c-nav__item" }
const _hoisted_83 = { class: "c-nav__icon" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "c-nav__name" }, "For Developers", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1)
const _hoisted_86 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_87 = { class: "c-subnav__item" }
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" CSS Rules ")
const _hoisted_89 = { class: "c-subnav__item" }
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" HTML Rules ")
const _hoisted_91 = {
  class: "c-nav__item",
  style: {"visibility":"hidden","height":"0","min-height":"0"}
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "c-nav__icon" }, null, -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "c-nav__name" }, " ", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1)
const _hoisted_95 = [
  _hoisted_92,
  _hoisted_93,
  _hoisted_94
]
const _hoisted_96 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("li", { class: "c-subnav__item" }, " ", -1)
const _hoisted_98 = [
  _hoisted_97
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_how_to_use = _resolveComponent("icon-how-to-use")!
  const _component_icon_design = _resolveComponent("icon-design")!
  const _component_transition_expand = _resolveComponent("transition-expand")!
  const _component_icon_layouts = _resolveComponent("icon-layouts")!
  const _component_icon_forms = _resolveComponent("icon-forms")!
  const _component_icon_components = _resolveComponent("icon-components")!
  const _component_icon_utilities = _resolveComponent("icon-utilities")!
  const _component_icon_devs = _resolveComponent("icon-devs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "c-logo",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("nav", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: { name: $data.HOW_TO_USE_ROUTE_NAME },
              class: "c-nav__link"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_icon_how_to_use)
                ]),
                _hoisted_10
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.designIsOpen = !$data.designIsOpen)),
              class: _normalizeClass([{ 'is-open': $data.designIsOpen }, "c-nav__link has-subnav"])
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_icon_design)
              ]),
              _hoisted_13,
              _hoisted_14
            ], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.designIsOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                      _createElementVNode("li", _hoisted_16, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.DESIGN_COLORS_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_18, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.DESIGN_TYPOGRAPHY_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_20, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.layoutsIsOpen = !$data.layoutsIsOpen)),
              class: _normalizeClass([{ 'is-open': $data.layoutsIsOpen }, "c-nav__link has-subnav"])
            }, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_icon_layouts)
              ]),
              _hoisted_22,
              _hoisted_23
            ], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.layoutsIsOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                      _createElementVNode("li", _hoisted_25, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.RESPONSIVE_BREAKPOINTS_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_26
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_27, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.APP_LAYOUTS_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_29, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.LAYOUT_OBJECTS_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_30
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_31, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.FLEXBOX_GRID_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_32
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_33, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.LAYOUT_HELPERS_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_34
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_35, [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($data.formsIsOpen = !$data.formsIsOpen)),
              class: _normalizeClass([{ 'is-open': $data.formsIsOpen }, "c-nav__link has-subnav"])
            }, [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_icon_forms)
              ]),
              _hoisted_37,
              _hoisted_38
            ], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.formsIsOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_39, [
                      _createElementVNode("li", _hoisted_40, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.FORM_GROUP_OBJECT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_41
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_42, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.INPUT_AND_VALIDATION_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_43
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_44, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.CHECK_AND_RADIO_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_45
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_46, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.SELECT_AND_OPTION_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_47
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_48, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.INPUT_WITH_ICON_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_49
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_50, [
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($data.componentsIsOpen = !$data.componentsIsOpen)),
              class: _normalizeClass([{ 'is-open': $data.componentsIsOpen }, "c-nav__link has-subnav"])
            }, [
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_icon_components)
              ]),
              _hoisted_52,
              _hoisted_53
            ], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.componentsIsOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_54, [
                      _createElementVNode("li", _hoisted_55, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.BUTTON_COMPONENT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_56
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_57, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.BASIC_BOX_COMPONENT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_58
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_59, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.USER_HINT_COMPONENT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_60
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_61, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.PILL_BUTTON_COMPONENT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_62
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_63, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.DATA_TABLE_COMPONENT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_64
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_65, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.TABS_COMPONENT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_66
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_67, [
            _createElementVNode("div", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($data.utilitiesIsOpen = !$data.utilitiesIsOpen)),
              class: _normalizeClass([{ 'is-open': $data.utilitiesIsOpen }, "c-nav__link has-subnav"])
            }, [
              _createElementVNode("div", _hoisted_68, [
                _createVNode(_component_icon_utilities)
              ]),
              _hoisted_69,
              _hoisted_70
            ], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.utilitiesIsOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_71, [
                      _createElementVNode("li", _hoisted_72, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.HOW_TO_USE_UTILITIES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_73
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_74, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.COLORS_UTILITY_CLASSES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_75
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_76, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.TYPOGRAPHY_UTILITY_CLASSES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_77
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_78, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.GAPS_UTILITY_CLASSES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_79
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_80, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.LAYOUT_UTILITY_CLASSES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_81
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_82, [
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($data.devsIsOpen = !$data.devsIsOpen)),
              class: _normalizeClass([{ 'is-open': $data.devsIsOpen }, "c-nav__link has-subnav"])
            }, [
              _createElementVNode("div", _hoisted_83, [
                _createVNode(_component_icon_devs)
              ]),
              _hoisted_84,
              _hoisted_85
            ], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.devsIsOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_86, [
                      _createElementVNode("li", _hoisted_87, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.CSS_RULES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_88
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_89, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.HTML_RULES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_90
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_91, [
            _createElementVNode("div", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($data.hiddenSection = !$data.hiddenSection)),
              class: _normalizeClass([{ 'is-open': $data.hiddenSection }, "c-nav__link has-subnav"])
            }, _hoisted_95, 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.hiddenSection)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_96, _hoisted_98))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}